import { com, kotlin } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import requireValidPaginationParameters from '../common/requireValidPaginationParameters'
import permissionGrantDTO, { PermissionGrantDTO } from '../../../../domain/permission/PermissionGrantDTO'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import KtList = kotlin.collections.KtList
import IndexedPaginatedResponse = com.eidu.api.pagination.IndexedPaginatedResponse

export type GetPermissionGrantsParameters = { pageIndex: number; pageSize: number }

const getPermissionGrants = async ({
  pageIndex,
  pageSize,
}: GetPermissionGrantsParameters): Promise<IndexedPaginatedResponse<PermissionGrantDTO>> => {
  requireValidPaginationParameters(pageIndex, pageSize)

  const response = await fetchAuthorized(
    (authContext) =>
      `${entityApiUrl}/organizations/${authContext.organizationId}/permissions/grants?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    {
      headers: {
        Accept: 'application/json',
      },
    }
  )
  if (response.status !== 200)
    throw Error(`Unexpected response code ${response.status} from getPermissionGrants endpoint`)
  const { documents, totalCount } = await response.json()
  const permissionGrants = documents.map(permissionGrantDTO)
  return new IndexedPaginatedResponse(KtList.fromJsArray(permissionGrants), totalCount)
}

export default getPermissionGrants
